import React from 'react';
import styled from 'styled-components';
import { faTimes } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';

interface Props {
  onClick: () => void,
}

const CloseButton:React.FC<Props> = ({ onClick }) => {
  return (
    <CloseButtonOuter type="button" onClick={onClick}>
      <FontAwesomeIcon icon={faTimes} />
    </CloseButtonOuter>
  );
};
export default CloseButton;

const CloseButtonOuter = styled.button`
  display: block;
  padding: 20px;
  line-height: 1em;
  border: none;
  -webkit-appearance: none;
  -moz-appearance: none;
  appearance: none;
  background: transparent;
  cursor: pointer;
  color: inherit;
`;
